import React from 'react'
import cookie from 'react-cookies'

export const ALPHA_ENGLISH = 'en';
export const ALPHA_CHINESE = 'cn';
export const ALPHA_DEFAULT = ALPHA_ENGLISH;

const locales = {
	[ALPHA_ENGLISH]: require('./' + ALPHA_ENGLISH),
	[ALPHA_CHINESE]: require('./' + ALPHA_CHINESE)
};

const supportedLocales = [ALPHA_ENGLISH, ALPHA_CHINESE];

function setLocale(locale) {
	let localeToSet = locale;

	if (supportedLocales.indexOf(localeToSet) === -1) {
		localeToSet = ALPHA_DEFAULT
	}

	cookie.save('alpha2', localeToSet, {path : '/', maxAge: 604800})
}

function getLocale() {
	return cookie.load('alpha2') || ALPHA_DEFAULT
}

function getLocalizedString(string, locale = null, options = {}) {
	let alpha2 = locale || getLocale();
	let output = locales[alpha2][string] || string;

	if (options.multiline) {
		return output.split('\n').map((chunk, index) => <span key={index}>{chunk}<br/></span>);
	}

	return output
}

function isEnglish() {
	return getLocale() === ALPHA_ENGLISH
}

function isChinese() {
	return getLocale() === ALPHA_CHINESE
}

export default {
	ALPHA_ENGLISH,
	ALPHA_CHINESE,
	ALPHA_DEFAULT,
	setLocale,
	getLocale,
	isEnglish,
	isChinese,
	str: getLocalizedString,
}



// WEBPACK FOOTER //
// ./src/locale/index.js